import { formatDate } from "../CustomDateTools";
import { useCallback, useState, useMemo } from "react"
import Table from 'react-bootstrap/Table';
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  createColumnHelper,
  SortingFn,
  SortingState,
  useReactTable,
} from '@tanstack/react-table'

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor(row => row.properties.site_code, {
    id: "site-code",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Code</>,
  }),
  columnHelper.accessor(row => row.properties.site_title, {
    id: "site-title",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Title</>,
  }),
  columnHelper.accessor(row => row.properties.site_type_, {
    id: "site-type",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Type</>,
  }),
  columnHelper.accessor(row => row.properties.site_sub_t, {
    id: "site-sub-type",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Sub Type</>,
  }),
  columnHelper.accessor(row => row.properties.site_stage, {
    id: "site_stage",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Stage</>,
  }),
  columnHelper.accessor(row => row.properties.commodity, {
    id: "commodity",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Commodity</>,
  }),
  columnHelper.accessor(row => row.properties.target_com, {
    id: "target_com",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Target Commodity</>,
  }),
  columnHelper.accessor(row => row.properties.site_commo, {
    id: "site_commo",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Site Commodity</>,
  }),
  columnHelper.accessor(row => row.properties.proj_title, {
    id: "proj_title",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Project Title</>,
  }),
  columnHelper.accessor(row => row.properties.proj_code, {
    id: "proj_code",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Project Code</>,
  }),
  columnHelper.accessor(row => row.properties.web_link, {
    id: "link",
    cell: info => <a target="_blank" href={info.getValue()}>
      Link
    </a>,
    header: () => <>Minedex Link</>,
  }),
]


export function MinedexTable({ mineDexGeoJSON, locateMinedexFeature, selectedMinedexFeature }) {

  const [sorting, setSorting] = useState([])

  const table = useReactTable({
    columns,
    data: mineDexGeoJSON.features,
    debugTable: false,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(), //client-side sorting
    onSortingChange: setSorting, //optionally control sorting state in your own scope for easy access
    // sortingFns: {
    //   sortStatusFn, //or provide our custom sorting function globally for all columns to be able to use
    // },
    //no need to pass pageCount or rowCount with client-side pagination as it is calculated automatically
    state: {
      sorting,
    },
    // autoResetPageIndex: false, // turn off page index reset when sorting or filtering - default on/true
    // enableMultiSort: false, //Don't allow shift key to sort multiple columns - default on/true
    // enableSorting: false, // - default on/true
    // enableSortingRemoval: false, //Don't allow - default on/true
    // isMultiSortEvent: (e) => true, //Make all clicks multi-sort - default requires `shift` key
    // maxMultiSortColCount: 3, // only allow 3 columns to be sorted at once - default is Infinity
  })

  return (
    <Table striped bordered hover>
      <thead style={{
        position: "sticky",
        top: "0"
      }}>
        {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => {
              return (
                <th
                  key={header.id}
                  colSpan={header.colSpan}>

                  {header.isPlaceholder ? null : (
                    <div
                      className={
                        header.column.getCanSort()
                          ? 'cursor-pointer select-none'
                          : ''
                      }
                      onClick={header.column.getToggleSortingHandler()}
                      title={
                        header.column.getCanSort()
                          ? header.column.getNextSortingOrder() === 'asc'
                            ? 'Sort ascending'
                            : header.column.getNextSortingOrder() === 'desc'
                              ? 'Sort descending'
                              : 'Clear sort'
                          : undefined
                      }
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {{
                        asc: ' 🔼',
                        desc: ' 🔽',
                      }[header.column.getIsSorted()] ?? null}
                    </div>
                  )}
                </th>
              )
            })}
          </tr>
        ))}
      </thead>
      <tbody>
        {table
          .getRowModel()
          .rows
          .map(row => {
            return (
              <tr key={row.id} className={(selectedMinedexFeature.properties !== undefined
                ? (selectedMinedexFeature.properties.__gid === row.original.properties.__gid ? "table-warning" : "")
                : ("")
              )} onClick={() => locateMinedexFeature(row.original)}>
                {row.getVisibleCells().map(cell => {
                  return (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
      </tbody>
    </Table>
  )
}